import YoutubePlayer from './components/YoutubePlayer'
import React, { useState, useEffect } from "react";
import io from "socket.io-client";
import Searchbar from "./components/Searchbar"
import UserListParent from "./components/UserListParent"
import QueueHistoryMenu from "./components/QueueHistoryMenu"
import {useCookies} from "react-cookie";
import './App.css'

const versionNumber = '1.3.2';

function App() {

  const [socket, setSocket] = useState(null);
  const [cookies, setCookie] = useCookies(["rave_username"]);
  const [showUserList, setShowUserList] = useState(false);
  const [currentVideo, setCurrentVideo] = useState({
    videoID: '',
    currentTime: 0.01,
    queueUUID: 0,
    paused: false
  });

  const toggleUserList = () => {
    if(showUserList){
      setShowUserList(false);
    } else {
      setShowUserList(true);
    }
  }

  const hideUserList = () => {
    setShowUserList(false);
  }

  useEffect(() => {
    const socket = io();
    socket.on('clearPlayer', () => {
      console.log('Clearing player...');
      setCurrentVideo({
        videoID: '',
        currentTime: 0.01,
        queueUUID: 0,
        paused: false
      })
    });
    socket.on('playVideoAt', (res) => {
      if (currentVideo.queueUUID != res.queueUUID){
        setCurrentVideo({
          videoID: res.videoID,
          currentTime: res.time,
          queueUUID: res.queueUUID,
          paused: res.paused
        })
      }
    });

    socket.on('connect', () => {
      socket.emit("getCurrentVideo");
      socket.emit("getQueueAndHistory");
      socket.emit("updateUsername", cookies["rave_username"]);
    });

    setSocket(socket)
    return () => socket.disconnect()
  }, []);

  const onSkip = () => {
    socket.emit("PlayNext", currentVideo.queueUUID)
  }

  return (
    <div className="App">
      <Searchbar socket={socket} versionNumber={versionNumber} onClientToggle={toggleUserList} cookies={cookies}/>
      <YoutubePlayer socket={socket} currentVideo={currentVideo} />
      <QueueHistoryMenu socket={socket} onSkip={onSkip} cookies={cookies}/>
      <UserListParent socket={socket} showUserList={showUserList} hideUserList={hideUserList}/>
    </div>
  );
}

export default App;
